module.exports = __webpack_public_path__ + "img/transnusa.262eae25.svg";